import { INTERNAL_API_ERROR_CODE } from '../constants';
import { APIError, DrugItem, FetchAttr } from '../types';
import { getData } from '../utils';

type GetDrugRequest = {
  id: string;
};

type GetDrugResponse = DrugItem;

const getDrug = async (
  requestObj: GetDrugRequest,
  attr?: FetchAttr
): Promise<GetDrugResponse> => {
  const { id } = requestObj;
  if (!id) {
    throw new APIError(INTERNAL_API_ERROR_CODE, 'ID was not provided');
  }
  const response = await getData(`drug/${id}`, attr);
  return response;
};

export default getDrug;
